// src/utils/GridColumnHelper.ts

import type { GridColDef, GridColType } from '@mui/x-data-grid';

import { formatDateForDisplay } from './DateHelper.tsx';
import type {BulkEditFieldConfiguration} from "./BulkEditHelper.tsx";


export const mapEsriTypeToMuiType = (esriType: string): GridColType => {
    switch (esriType) {
        case 'small-integer':
        case 'integer':
        case 'single':
        case 'double':
        case 'long':
        case 'oid':
        case 'esriFieldTypeSmallInteger':
        case 'esriFieldTypeInteger':
        case 'esriFieldTypeSingle':
        case 'esriFieldTypeDouble':
        case 'esriFieldTypeOID':
            return 'number';
        case 'string':
        case 'guid':
        case 'global-id':
        case 'xml':
        case 'esriFieldTypeString':
        case 'esriFieldTypeGUID':
        case 'esriFieldTypeGlobalID':
        case 'esriFieldTypeXML':
            return 'string';
        case 'date':
        case 'date-only':
        case 'time-only':
        case 'esriFieldTypeDate':
            return 'dateTime';
        case 'geometry':
        case 'blob':
        case 'raster':
        case 'esriFieldTypeGeometry':
        case 'esriFieldTypeBlob':
        case 'esriFieldTypeRaster':
        default:
            return 'string';
    }
};

export const mapEsriFieldsToDataGridColumns = (
    fields: __esri.Field[],
    gridFields: BulkEditFieldConfiguration[] = []
): GridColDef[] => {
    return gridFields.map((field) => {
        const esriField = fields.find((f) => f.name === field.field);

        const muiType = mapEsriTypeToMuiType(esriField?.type || '');

        const colDef: GridColDef = {
            field: field.field,
            headerName: field.alias ? field.alias : esriField?.alias ? esriField.alias : field.field,
            editable: field.editable || false,
            width: 150,
            type: muiType || 'string'
        };

        // format all date fields with the same formatter, can be overridden by field configuration
        if (muiType === 'dateTime') {
            colDef.valueFormatter  = (value => {
                if (!value) return '';
                    return formatDateForDisplay(value)
            })
        }

        if (field.valueFormatter) {
            colDef.valueFormatter = field.valueFormatter
        }

        if(field.renderCell){
            colDef.renderCell = field.renderCell
        }

        return colDef
    });
};
